import ResultatGE from '@/views/analyse/resultat-ge';
import ResultatCRP from '@/views/analyse/resultat-crp';

export default {
    name: 'examen-bio-resultats',
    components: {
        ResultatGE, ResultatCRP
    },
    props: {
        type_analyse: Object
    },
    data () {
        return {

        }
    },
    computed: {

    },
    mounted () {

    },
    methods: {

    }
}


